import * as React from 'react';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';
import { useNavigate } from "react-router-dom"
import { Status, Card, ActionRow } from './style'
import { ticketsStatus } from '../../../functions/ticketsStatus'
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useTranslation } from 'react-i18next';
import BlockIcon from '@mui/icons-material/Block'

export default function TicketSummery(props) {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'dashboard' });
  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  const navigate = useNavigate()
  const { data } = props

  const selfUser = JSON.parse(localStorage.getItem('user'))

  const isImportant = data.user.important
  const isBanned = data.user.banned
  const categoryName = selfUser.type === 'user' ? data.category?.parent?.name || data.category.name : data.category.name

  return (
    <Card
      dir={direction}
      style={{cursor: 'pointer'}}
      status={data.status}
      isImportant={isImportant}
      onClick={() => navigate(`/ticket/${data.id}`)}>
      <CardHeader
        avatar={
          <Avatar
            sx={{ bgcolor: red[500] }}
            style={{
              marginRight: 0,
              marginLeft: 4
            }}
          >
            {data.user.first_name.charAt(0)}
          </Avatar>
        }
        action={
          <ActionRow>
            {selfUser?.type === 'admin' && !!isBanned &&
              <BlockIcon
                style={{ color: '#cd0000' }}
              />
            }
            {selfUser.type === 'admin' && !!isImportant &&
             <StarIcon
              style={{ color: '#FFD700'}} />
            }
            {selfUser.type === 'admin' && !isImportant &&
             <StarBorderIcon
              style={{ color: '#FFD700'}} />
            }
            <Status status={data.status}>
              {ticketsStatus[data.status]}
            </Status>
          </ActionRow>
        }
        title={`${data.user.first_name} ${data.user.last_name}`}
        subheader={t('category_name', {categoryName: categoryName})}
        style={{
          padding: 0
        }}
      />
    </Card>
  );
}
